// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import  VueQuillEditor from 'vue-quill-editor'
import 'babel-polyfill'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { Button, ButtonGroup, Card, Dropdown, DropdownMenu, DropdownItem, Dialog, Form, FormItem, Tooltip, Table, TableColumn, Pagination, Switch, Scrollbar, Tree, Popover, Cascader, Checkbox, CheckboxGroup, Tabs, TabPane, Radio, RadioGroup, Select, Option, OptionGroup, Upload, Input, Autocomplete, DatePicker, Menu, Submenu, MenuItem, Transfer, MenuItemGroup, Loading, Message, Alert, Carousel, carouselItem } from 'element-ui';
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tooltip)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Submenu)
Vue.use(Switch)
Vue.use(Scrollbar)
Vue.use(ButtonGroup)
Vue.use(Tree)
Vue.use(Cascader)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Autocomplete)
Vue.use(Transfer)
Vue.use(Card)
Vue.use(VueQuillEditor)
Vue.use(Alert)
Vue.use(Carousel)
Vue.use(carouselItem)

Vue.prototype.$message = Message
window.globalRouter = router;

Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};

if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js